module.exports = __webpack_public_path__ + "img/WeChat-&-QQ-compared-to-Rest-of-World.fd3e30c4.png";